import type { IntlShape } from 'react-intl'

import { maskAnonymisedValue } from 'Utilities'

/**
 * A shipment keeps the address it was requested to, and the encryption replaces the fields of an
 * employee's own address where it points at one. Every line of the card goes through here, so this
 * is where such a field is caught rather than printed.
 */
export const renderShippingAddressLine = (
  value: string | null | undefined,
  intl?: IntlShape,
) => {
  const masked = maskAnonymisedValue(value, intl)

  if (!masked) {
    return null
  }

  return <p className="m-0">{masked}</p>
}
